import { createComponent } from 'react-fela'

import { breakpoints } from '../constants/theme'
import calculatePerBreakpoint from '../utils/calculatePerBreakpoint'

const Row = props => ({
  padding: 0,
  justifyContent: props.justifyContent || props.center && 'center',
  alignItems: props.alignItems || props.center && 'center',
  flex: props.flex,
  maxWidth: '100%',
  width: '100%',
  order: props.order,
  alignSelf: 'stretch',
  flexWrap: 'wrap',
  ['@media (min-width: ' + breakpoints.min768 + 'px)']: {
    flexDirection: 'row'
  },
  extend: [
    calculatePerBreakpoint(props.columns, value => ({
    padding: '0 ' + ((12 - value) / 12 * 50) + '%'
  })),
  calculatePerBreakpoint(props.orders, value => ({
    order: value
  }))]
})

export default createComponent(Row, 'div', [
  'data-scroll-effect',
  'data-scroll-offset'
])



// WEBPACK FOOTER //
// ../components/Row.js